import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsN26Component } from './simple-icons-n26.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsN26Component ],
    exports:      [ SimpleIconsN26Component ],
    bootstrap:    []
})
export class SimpleIconsN26Module {}
